import dayjs from 'dayjs'
import { CircleIcon, TimerIcon } from 'lucide-react'

import { cn } from '@/lib/utils'
import { noop } from '@/lib/utils/function'

export interface CaseScheduledAlertButtonProps {
  order: number
  alertType: string
  deadline: string
  notificationTime: string
  noninteractive?: boolean
  className?: string
  onClick?: VoidFunction
}

export const CaseSchedulesAlertButton = ({
  order,
  alertType,
  deadline,
  notificationTime,
  noninteractive = false,
  className,
  onClick,
}: CaseScheduledAlertButtonProps) => {
  return (
    <button
      type="button"
      className={cn(
        'flex flex-col',
        'p-4',
        'bg-secondary',
        'rounded-[8px]',
        'hover:bg-secondary/75',
        {
          'pointer-events-none': noninteractive,
        },
        className
      )}
      onClick={!noninteractive ? onClick : noop}
    >
      <span className={cn('flex items-center', 'text-sm font-medium text-foreground')}>
        <span className={cn('flex')}>
          <CircleIcon
            size={20}
            className={cn('stroke-transparent', {
              'fill-blue-600': order % 9 === 0,
              'fill-indigo-600': order % 9 === 1,
              'fill-sky-600': order % 9 === 2,
              'fill-amber-600': order % 9 === 3,
              'fill-red-600': order % 9 === 4,
              'fill-fuchsia-600': order % 9 === 5,
              'fill-orange-600': order % 9 === 6,
              'fill-yellow-600': order % 9 === 7,
              'fill-pink-600': order % 9 === 8,
            })}
          />
          <span className={cn('ml-2.5')}>{alertType}</span>
          <span className={cn('mx-2.5')}>•</span>
          <span>{dayjs.utc(deadline).format('MM-DD-YYYY')}</span>
        </span>
      </span>

      <span className={cn('flex items-center', 'mt-2.5', 'text-sm font-medium text-foreground')}>
        <TimerIcon size={20} />
        <span className={cn('ml-2.5')}>Notification Date</span>
        <span className={cn('mx-2.5')}>•</span>
        <span>{dayjs.utc(notificationTime).format('MM-DD-YYYY')}</span>
      </span>
    </button>
  )
}
